export default __webpack_public_path__ + "static/media/07.b92b96a7.jpg";